import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { BaseSubMaintenanceController } from '../../_base/BaseSubMaintenanceController';
import { ProductTimeItemMaintenanceDto } from './ProductTimeItemMaintenanceDto';
import { ProductTimeListMaintenanceDto } from './ProductTimeListMaintenanceDto';


@Injectable()
export class ProductTimeSubMaintenanceController extends BaseSubMaintenanceController<ProductTimeListMaintenanceDto, ProductTimeItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {
        super(http, alertService, translateService, loadingService, router, "address/producttime");
    }

    public getResourceRoot(): string {
        return "PRODUCT.TIME";
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/activity/address/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}
